import React from 'react';
import {
  Button,
  ButtonProps,
  BreadcrumbItem,
  BreadcrumbItemProps,
  BreadcrumbLink,
} from '@chakra-ui/react';
import { Link, generatePath, useHistory } from 'react-router-dom';
import {
  CAMPAIGN_LIST,
  CAMPAIGN_CREATE,
  CAMPAIGN_SHOW,
  CAMPAIGN_EDIT,
  CAMPAIGN_CODES_ASSIGN,
} from 'routes';
import { withCurrentCampaignId } from 'hoc';
import { useAppSelector } from 'hooks';
import { selectCampaign } from 'store/campaigns';
import { CampaignId } from './Campaign.types';
import { useTranslation } from 'react-i18next';

export function campaignsListPage(): string {
  return generatePath(CAMPAIGN_LIST);
}

export function campaignCreatePage(): string {
  return generatePath(CAMPAIGN_CREATE);
}

export function campaignShowPage(campaignId: number): string {
  return generatePath(CAMPAIGN_SHOW, { campaignId });
}

export function campaignEditPage(campaignId: number): string {
  return generatePath(CAMPAIGN_EDIT, { campaignId });
}

export function campaignCodesAssignPage(campaignId: number): string {
  return generatePath(CAMPAIGN_CODES_ASSIGN, { campaignId });
}

export const CampaignsListLink = ({
  children,
  ...props
}: ButtonProps): JSX.Element => {
  return (
    <Button to={campaignsListPage()} as={Link} {...props}>
      {children}
    </Button>
  );
};

export const CampaignsListBreadcrumbLink = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <BreadcrumbItem>
      <BreadcrumbLink to={campaignsListPage()} as={Link}>
        {t('campaignsList', 'Lista kampanii')}
      </BreadcrumbLink>
    </BreadcrumbItem>
  );
};

export const ShowCampaignLink = ({
  children,
  ...props
}: CampaignId & ButtonProps): JSX.Element => {
  const history = useHistory();
  const handleClick = () => {
    history.goBack();
  };
  return (
    <Button onClick={handleClick} as={Link} {...props}>
      {children}
    </Button>
  );
};

export const ShowCampaignBreadcrumbLink = ({
  campaignId,
  campaignName: campaignNameProp,
  ...props
}: CampaignId & {
  campaignName?: string;
} & BreadcrumbItemProps): JSX.Element => {
  const { t } = useTranslation();
  const campaign = useAppSelector(state => selectCampaign(state, campaignId));
  const name = campaignNameProp ?? campaign?.name ?? '...';

  if (!campaignId)
    return (
      <BreadcrumbItem {...props}>
        <BreadcrumbLink>...</BreadcrumbLink>
      </BreadcrumbItem>
    );

  return (
    <BreadcrumbItem {...props}>
      <BreadcrumbLink to={campaignShowPage(campaignId)} as={Link}>
        {t('campaign.nameWithLabel', { val: name })}
      </BreadcrumbLink>
    </BreadcrumbItem>
  );
};

export const ShowCurrentCampaignLink = withCurrentCampaignId(ShowCampaignLink);
export const ShowCurrentCampaignBreadcrumbLink = withCurrentCampaignId(
  ShowCampaignBreadcrumbLink,
);
